<template>
  <main id="app" :class="{'loading' : !loaded}">
    <main-navigation v-if="$router.currentRoute.fullPath === '/'"/>
    <loader-full v-on:hasLoaded="hasLoaded" />
    <router-view />
    <cookie-notice />
  </main>
</template>

<script>
// @ is an alias to /src
import navigation from '@/components/navigation'
import loader from '@/components/loader'
import cookieNotice from '@/components/cookie-notice'

export default {
  name: 'Home',
  components: {
    'main-navigation': navigation,
    'loader-full': loader,
    'cookie-notice': cookieNotice
  },
  data () {
    return {
      loaded: false
    }
  },
  methods: {
    hasLoaded (hasLoaded) {
      this.loaded = hasLoaded
    }
  }
}

</script>

<style lang="scss">
  // Tailwind
  @import './assets/tailwind/base';
  @import './assets/tailwind/tailwind';
  @import './assets/tailwind/utilities';
  // Global Styles
  @import './assets/styles/styles';
</style>
